export default "__VITE_ASSET__de5c442e__"